import * as React from "react";
import { useDispatch } from "react-redux";

// store, state
import { constants } from "../../../../../store/roundingErrands";
import {
  updateActiveFormInstance,
  useFormInstanceField,
} from "../../../../../store/base";

// style, design
import DocumentUploader from "../../../Base/Fields/DocumentUploader";

export default ({ method }) => {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;

  const docFileName = useFormInstanceField({
    storeName,
    fieldKey: "completion_files[0].file",
  });
  const docTitle = useFormInstanceField({
    storeName,
    fieldKey: "title",
  });

  React.useEffect(() => {
    if (docFileName && !docTitle) {
      dispatch(
        updateActiveFormInstance({
          storeName,
          data: { title: docFileName },
        })
      );
    }
  }, [docFileName]);

  return (
    <>
      <DocumentUploader
        storeName={storeName}
        fieldKey={`completion_files.[${0}].file`}
        instructionsKey={"completion_files.file"}
        method={method}
        title="Dokumentuppladdning"
      />
    </>
  );
};
